module.exports = __webpack_public_path__ + "static/img/weixin.894df3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weixin.png
// module id = AVav
// module chunks = 2